export function WhyItWorks() {
  return (
    <section data-testid="why-it-works-section" className="relative overflow-hidden bg-white">
      <div
        aria-hidden
        className="absolute top-0 right-0 w-[500px] h-[500px] opacity-[0.03]"
        style={{ background: "radial-gradient(circle, #F6A041 0%, transparent 70%)" }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[12px] md:pt-[34px] pb-[44px] md:pb-[66px] relative z-[1]">
        <div className="reveal">
          <h2 className="text-sm font-medium tracking-[0.28em] uppercase text-[#F6A041] mb-[36px]">
            Why It Works
          </h2>

          <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed max-w-[460px]">
            Progress rarely comes from finding more time.
          </p>

          <p className="font-display text-[32px] sm:text-[42px] lg:text-[54px] text-[#159E9A] leading-[1.1] tracking-tight max-w-[760px] ml-auto text-right mt-[4px]">
            It comes from protecting the time you already have.
          </p>

          <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed max-w-[460px] mt-[36px]">
            Spark Sessions remove just enough friction that beginning becomes easier.
          </p>

          <p className="font-display text-[32px] sm:text-[42px] lg:text-[54px] text-[#1C1917] leading-[1.1] tracking-tight max-w-[760px] ml-auto text-right mt-[4px]">
            And once we begin, momentum usually takes over.
          </p>
        </div>
      </div>
    </section>
  );
}
